import React from 'react';
import { useWalletRegistrationModalContext } from '../../../contexts/wallet-registration-modal-context';
import { estimateResponseTime } from './response-time-estimator';
import { ModalFooterProgressBar as ModalFooterProgressBarBase } from 'ui-components/components/modal/modal-footer/modal-footer-progress-bar';

export const ModalFooterProgressBar = () => {
  const { walletToRegister } = useWalletRegistrationModalContext();
  const estimatedResponseTime = estimateResponseTime(walletToRegister);

  return <ModalFooterProgressBarBase estimatedMilliseconds={estimatedResponseTime} />;
};
